import Individual from "./individual/Label";

export default {   Individual };
